import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[caiMask]',
})
export class CaiMaskDirective implements OnInit, OnDestroy {
  @Input()
  set caiControl(control: AbstractControl) {
    this._caiControl = control;
  }

  private _caiControl: AbstractControl;

  private _unsubscribeAll = new Subject<void>();
  constructor() {}

  ngOnInit() {
    this._caiControl.valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        const isValidExp = /(^[0-9a-zA-Z-]{1,37}$)/.test(value);
        const newVal = isValidExp ? value : value.replace(/[^\d,\w,-]+/g, '');
        console.log({ value, newVal, length: newVal.length, isValidExp });
        this._caiControl.setValue(newVal, { emitEvent: false });
      });
  }

  ngOnDestroy() {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}

// const isCharOrHyphen = (charStr: string): boolean => {
//   return !!/\d|\w/.test(charStr) || charStr === '-';
// };
